import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'nf-vote',
  templateUrl: './vote.component.html',
  styleUrls: ['./vote.component.css']
})
export class VoteComponent implements OnInit {

  nfData = [];
  @Input() currentUser;
  @Input('nfData') set nfDataChange(data) {
    console.log(data)
    if (data) {
      this.nfData = data.voters || [];
      if (this.currentUser) {
        for (const item of this.nfData) {
          if (item.id === this.currentUser.id) {
            this.currentUserChecked = true;
            break;
          }
        }
      } else {
        this.currentUser = {};
      }
    }
  }
  @Input() disabled = false;
  @Output() getData: EventEmitter<any> = new EventEmitter<any>();
  currentUserChecked = false;

  constructor() { }

  ngOnInit(): void {
  }

  changeVoteStatus() {
    if (this.disabled)
      return;
    this.currentUserChecked = !this.currentUserChecked;
    if (this.currentUserChecked) {
      this.nfData.push({
        id: this.currentUser.id,
        name: this.currentUser.name
      });
    } else {
      const index = this.nfData.findIndex(item => item.id == this.currentUser.id);
      this.nfData.splice(index, 1);
    }
    this.getData.emit(this.nfData);
  }
}
